module.exports = __webpack_public_path__ + "img/img53.8e3ea38d.svg";